<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { AppMultiSelect } from '@shared/ui/selects'
import { ModalDefault } from '@shared/ui/modals'
import { BtnCheckbox, BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDisciplineScheduleFilters } from '../../model/modal-discipline-schedule-filters.hook'

defineOptions({
  name: 'ModalDisciplineScheduleFilters',
})

const {
  refGender,
  refFeatures,
  refIsPremium,
  refHasPremiumHint,
  refGenderOptions,
  refFeatureOptions,
  refIsLoading,
  togglePremium,
  close,
  back,
  confirm,
} = useModalDisciplineScheduleFilters()
</script>

<template>
  <ModalDefault
    show
    title="Set filters to assign tutor"
    :loading="refIsLoading"
    class-name="modal-discipline-schedule-step"
    is-close-button
    is-back-button
    @click:overlay="close"
    @click:close="close"
    @click:back="back"
  >
    <div class="modal-discipline-schedule-filters">
      <AppText
        v-if="refHasPremiumHint"
        name="body1"
      >
        You need to choose a premium tutor for this kid
      </AppText>
      <AppMultiSelect
        v-model="refGender"
        :options="refGenderOptions"
        label="Gender"
        placeholder="All"
        clearable
      />
      <AppMultiSelect
        v-model="refFeatures"
        :options="refFeatureOptions"
        label="Special features"
        placeholder="All"
        clearable
      />
      <BtnCheckbox
        :checked="refIsPremium"
        class="modal-discipline-schedule-filters__premium"
        @click="togglePremium"
      >
        <span class="modal-discipline-schedule-filters__premium-text">
          <AppText name="body1">
            Assign premium tutor only
          </AppText>
          <AppText
            name="body2"
            color="slate-500"
          >
            Enable this setting to assign only Premium tutors for a premium subscription user.
          </AppText>
        </span>
      </BtnCheckbox>
    </div>
    <template #controls>
      <BtnPrimary
        text="Continue"
        color="emerald"
        :disabled="refIsLoading"
        @click="confirm"
      />
      <BtnSecondary
        text="Cancel"
        color="black"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineSchedule.scss" />
<style scoped lang="scss" src="./ModalDisciplineScheduleFilters.scss" />
